import axios from 'axios';

const api = '/api/assistants';

export const getAssistant = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getAssistants = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const saveAssistant = assistant => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, assistant);
};

export const updateAssistant = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
